import { Project } from "./types";
import dstShowcase from "../assets/dst-showcase-mobile.webp";
import angularIcon from "../assets/angular-icon.svg";
import typescriptIcon from "../assets/typescript-icon.svg";
import sassIcon from "../assets/sass-icon.svg";
import threejsIcon from "../assets/Threejs-logo.svg";

export const porscheInformatikProject: Project = {
  title: "Porsche Informatik Diplomarbeit",
  description:
    'I had an Internship in which I worked on a project for Porsche Informatik. A so called "Diplomarbeit". It allows the user to search all kinds of identifiers of a vehicle and has a dashboard for displaying all kinds of car data. The project was built with Angular and TypeScript. We also used the @ngxs/store package for state management. I learned a lot about working in a team, about tickets, merge requests, proper git usage and how a real world project is structured and managed.',
  date: "07/2024 - 09/2024",
  image: dstShowcase,
  imageAlt: "Porsche Informatik project showcase",
  technologies: [angularIcon, typescriptIcon, sassIcon],
};
